import { BrandLogo } from '@calendly/ui/components/brand-logo'
import { Button } from '@calendly/ui/components/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@calendly/ui/components/dropdown-menu'
import { IconCheck } from '@calendly/ui/components/glyphs/IconCheck'
import { IconChevronDown } from '@calendly/ui/components/glyphs/IconChevronDown'
import { IconChevronUp } from '@calendly/ui/components/glyphs/IconChevronUp'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { cx } from '@linaria/core'
import { useState } from 'react'

import {
  processorMenuContainerCss,
  processorMenuContentCss,
  processorOptionContentCss,
  processorTriggerCss,
  providerLogoCss,
  providerLogoDisabledCss,
  providerOptionCss,
} from './styles'

const PROVIDERS_LOGOS = {
  stripe: 'stripe',
  paypal: 'pay-pal',
  paypal_ppcp: 'pay-pal',
}

export const PaymentProcessorSelect = ({
  value,
  options,
  onChange,
  'aria-label': ariaLabel,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const selectedOption = options.find((option) => option.value === value) || options[0]

  if (!selectedOption) {
    return null
  }

  const handleClose = () => setIsOpen(false)

  const handleToggle = () => {
    setIsOpen((open) => !open)
  }

  const handleSelect = (option) => {
    if (option.disabled) {
      return
    }

    setIsOpen(false)

    if (option.value !== value) {
      onChange(option.value)
    }
  }

  return (
    <div className={processorMenuContainerCss}>
      <DropdownMenu isOpen={isOpen} onClose={handleClose}>
        <DropdownMenuTrigger>
          <Button
            appearance="secondary-outline"
            size="small"
            responsive={false}
            className={processorTriggerCss}
            onClick={handleToggle}
            aria-label={ariaLabel}
            aria-expanded={isOpen}
            aria-haspopup="menu"
            trailingIcon={isOpen ? IconChevronUp : IconChevronDown}
            data-testid="payment-processor-select"
          >
            <BrandLogo
              className={providerLogoCss}
              name={PROVIDERS_LOGOS[selectedOption.value]}
            />
            {selectedOption.name}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          placement="bottom end"
          className={processorMenuContentCss}
          data-testid="payment-processor-menu"
        >
          {options.map((option) => {
            const isSelected = option.value === value && !option.disabled

            return (
              <DropdownMenuItem
                key={option.value}
                textValue={option.name}
                disabled={option.disabled}
                onSelect={() => handleSelect(option)}
                data-testid={`payment-processor-option-${option.value}`}
              >
                <span className={processorOptionContentCss}>
                  <span className={providerOptionCss}>
                    <BrandLogo
                      className={cx(
                        providerLogoCss,
                        option.disabled && providerLogoDisabledCss
                      )}
                      name={PROVIDERS_LOGOS[option.value]}
                    />
                    {option.name}
                  </span>
                  {isSelected ? (
                    <UiIcon icon={IconCheck} size="small" title="" />
                  ) : null}
                </span>
              </DropdownMenuItem>
            )
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
